import { WalletError } from "@solana/wallet-adapter-base";

/**
 * The errors the generic layer raises and the picker renders. Frozen at step
 * 0. Matched elsewhere by `name`, so the server-capable error libraries never
 * import this module.
 */

/**
 * The wallet's connection to the page went away under a request (extension
 * updated, disabled or restarted), or it never answered within the ceiling.
 * Raised in place of a signature: nothing it covered was sent.
 */
export class WalletConnectionLostError extends WalletError {
  name = "WalletConnectionLostError";
}

/**
 * A wallet-broadcast send that never answered within `MAX_SEND_MS`. Unlike a
 * lost connection it may already have been sent, so it is never told as
 * "nothing was signed".
 */
export class WalletSendUnansweredError extends WalletError {
  name = "WalletSendUnansweredError";
}

/** The wallet connected without sharing a Solana account. */
export class NoSolanaAccountError extends Error {
  name = "NoSolanaAccountError";
}

/**
 * Raised inside another wallet's in-app browser, where leaving on our own
 * would be presumptuous: `href` opens the page in the wallet asked for.
 */
export class OpenInWalletError extends Error {
  name = "OpenInWalletError";
  constructor(
    message: string,
    readonly href: string
  ) {
    super(message);
  }
}
